export default __webpack_public_path__ + "static/media/image1.cfc7b7c8.svg";